const zhCN = {
  common: {
    appName: '舆情监测系统',
    loading: '加载中...',
    noData: '暂无数据',
    confirm: '确定',
    cancel: '取消',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    add: '新增',
    search: '搜索',
    export: '导出',
    back: '返回',
    next: '下一页',
    prev: '上一页',
    submit: '提交',
    reset: '重置',
    close: '关闭',
    all: '全部',
    total: '共',
    actions: '操作',
    status: '状态',
    type: '类型',
    name: '名称',
    time: '时间',
    operation: '操作',
    success: '成功',
    failed: '失败',
    yes: '是',
    no: '否',
    page: '第',
    of: '页 / 共',
    items: '条',
    selectPlaceholder: '请选择',
    inputPlaceholder: '请输入',
    viewOriginal: '查看原文',
  },
  nav: {
    dashboard: '综合看板',
    monitor: '监测管理',
    monitorManage: '监测管理',
    monitorData: '数据监测',
    analysis: '监测分析',
    volume: '声量监测',
    publicOption: '事件分析',
    report: '分析报告',
    settings: '系统设置',
    settingsWarning: '预警设置',
    settingsWarningMsg: '预警消息',
    settingsPreference: '偏好设置',
    settingsUsers: '用户管理',
    settingsFeedback: '反馈建议',
  },
  login: {
    title: '登录',
    subtitle: '舆情监测系统',
    phone: '手机号',
    phonePlaceholder: '请输入手机号',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    signIn: '登录',
    signingIn: '登录中...',
    logout: '退出登录',
    invalidCredentials: '手机号或密码错误',
  },
  dashboard: {
    title: '综合看板',
    todayStatus: '今日舆情情况',
    warningAlerts: '预警舆情',
    hotEvents: '热点事件',
    hotSearch: '热点搜索词',
    leadersOpinion: '领导人舆情',
    pushOpinion: '推送舆情',
    reprintQuery: '转载查询',
    collection: '收藏贴文',
    hotWeibo: '微博热点',
    hotWechat: '微信热点',
    hotDouyin: '抖音热点',
    hotBilibili: 'B站热点',
    onlineUsers: '在线用户',
    dailyReport: '日报',
    weeklyReport: '周报',
  },
  monitor: {
    title: '监测管理',
    addGroup: '新增方案组',
    editGroup: '编辑方案组',
    deleteGroup: '删除方案组',
    addProject: '新增方案',
    editProject: '编辑方案',
    deleteProject: '删除方案',
    groupName: '方案组名称',
    projectName: '方案名称',
    projectType: '方案类型',
    normal: '普通',
    advanced: '高级',
    subjectWord: '主体词',
    characterWord: '人物词',
    eventWord: '事件词',
    regionalWord: '地域词',
    stopWord: '屏蔽词',
    projectDescription: '方案描述',
    selectProject: '请从监测管理页面选择一个项目',
    deleteConfirm: '确定要删除吗？',
    groupDeleteConfirm: '删除该方案组将同时删除组下所有方案，是否继续？',
    dataList: '数据监测',
    articleTitle: '文章标题',
    sourceName: '来源',
    publishTime: '发布时间',
    emotion: '情感',
    positive: '正面',
    neutral: '中性',
    negative: '负面',
    similarCount: '相似数',
    sourcePlatform: '来源平台',
    keyword: '关键词',
    timeRange: '时间范围',
    hours24: '24小时',
    today: '今天',
    yesterday: '昨天',
    days3: '3天',
    days7: '7天',
    days15: '15天',
    days30: '30天',
    custom: '自定义',
    emotionFilter: '情感筛选',
    sourceFilter: '来源筛选',
    sortBy: '排序方式',
    timeDesc: '时间降序',
    timeAsc: '时间升序',
    similarDesc: '相似数倒序',
    matchMode: '匹配方式',
    fullText: '全文',
    titleOnly: '标题',
    contentOnly: '正文',
    preciseFilter: '精准筛选',
    mergeSimilar: '合并相似',
    sourcePlatforms: '监测来源平台',
    sourcePlatformsHint: '选择需要监测的来源平台',
    platformsCount: '个平台',
    projectPlatforms: '项目平台',
    sourcePlatformFilter: '来源平台',
    monitorDuration: '数据时间范围',
    monitorDurationHint: '设置方案的数据监测时间范围，最长1年（365天）',
    days: '天',
    days365: '1年',
  },
  analysis: {
    title: '监测分析',
    dataOverview: '数据概览',
    emotionalProportion: '情感占比',
    planWordHit: '方案命中主体词',
    keywordEmotionTrend: '关键词情感分析走势',
    hotEventRanking: '热点事件排名',
    highwordCloud: '关键词高频分布统计',
    keywordIndex: '高频词指数',
    mediaActivity: '媒体活跃度分析',
    hotSpotRanking: '热点地区排名',
    dataSourceDistribution: '数据来源分布',
    dataSourceAnalysis: '数据来源分析',
    keywordExposureRank: '关键词曝光度环比排行',
    selfmediaVolumeRank: '自媒体渠道声量排名',
    popularInformation: '热门资讯',
    popularEvent: '热点事件',
    hotCompany: '热点公司',
    hotPeople: '热点人物',
    hotSpot: '热点地区',
    relativeNews: '相关资讯',
    categoryRank: '分类趋势',
    industrialDistribution: '行业分布',
    eventStatistics: '事件统计',
    keywordEmotionStatistical: '关键词情感分析数据统计分布',
    timePeriod: '时间周期',
    update: '更新分析',
    totalArticles: '文章总量',
    newsCount: '资讯数量',
    socialCount: '社交数量',
  },
  volume: {
    title: '声量监测',
    totalVolume: '总声量',
    newsVolume: '新闻声量',
    socialVolume: '社交声量',
    keywordEmotionStatistical: '关键词情感分析数据统计分布',
    keywordSourceDistribution: '关键词数据来源分布',
    keywordNewsRank: '关键词资讯数量排名',
    topicClusterAnalysis: '主题观点聚类分析',
    keywordEmotionTrend: '关键词情感分析数据走势',
    highwordCloud: '关键词高频分布统计',
    keywordExposureRank: '关键词曝光度环比排行',
    keywordCorrelationNews: '热点内容聚类分析排名',
    userPortraitLabel: '用户画像标签',
    socialUserVolumeRank: '社交网络用户声量排名',
    mediaUserVolumeRank: '自媒体用户声量排名',
  },
  publicOption: {
    title: '事件分析',
    addEvent: '创建事件',
    editEvent: '编辑事件',
    deleteEvent: '删除事件',
    eventName: '任务名称',
    eventKeywords: '任务关键词',
    eventStartTime: '开始时间',
    eventEndTime: '结束时间',
    eventStopWords: '屏蔽词',
    reportList: '报告列表',
    reportDetail: '研判分析详情',
    backAnalysis: '溯源分析',
    eventContext: '事件脉络',
    eventTrace: '事件跟踪',
    hotAnalysis: '热点分析',
    netizensAnalysis: '重点网民分析',
    statistics: '统计',
    propagationAnalysis: '传播分析',
    thematicAnalysis: '专题分析',
    unscrambleContent: '内容解读',
    judicialOpinion: '司法舆情分析研判',
    statusCreating: '正在创建',
    statusFailed: '创建失败',
    statusSuccess: '创建成功',
  },
  report: {
    title: '分析报告',
    dailyReport: '日报',
    weeklyReport: '周报',
    monthlyReport: '月报',
    reportName: '报告名称',
    reportType: '报告类型',
    reportPeriod: '报告周期',
    reportStatus: '报告状态',
    generating: '已生成任务',
    editing: '正在编制',
    completed: '编制成功',
    failed: '编制失败',
    deleteSelected: '批量删除',
    compile: '编制',
    viewDetail: '查看详情',
    dataOverview: '数据概览',
    emotionAnalysis: '情感分析',
    hotEventRanking: '热点事件排名',
    mediaActivity: '媒体活跃度分析',
    selfMediaRanking: '自媒体热度排名',
    highWordIndex: '高频词指数',
    hotSpotRanking: '热点地区排名',
    netizenWordCloud: '网民高频词云',
    mediaWordCloud: '媒体高频词云',
    hotPeople: '热点人物',
    hotSpots: '热点地区',
    topicClustering: '主题观点聚类分析',
    socialVRanking: '社交网络大V热度排名',
  },
  settings: {
    title: '系统设置',
    warning: {
      title: '预警设置',
      warningName: '预警名称',
      warningWord: '预警词',
      warningSwitch: '预警开关',
      warningClassify: '来源类型',
      warningContent: '预警内容',
      allContent: '全部',
      sensitiveOnly: '仅敏感',
      warningMatch: '匹配方式',
      warningDeduplication: '预警去重',
      warningSource: '预警来源',
      systemPush: '系统推送',
      emailPush: '邮箱推送',
      receiveTime: '接收时间',
      weekendWarning: '周末预警',
      warningInterval: '预警间隔',
      realtime: '实时预警',
      scheduled: '定时预警',
      messageList: '预警消息',
      edit: '编辑预警',
    },
    preference: {
      title: '偏好设置',
      timeRange: '时间范围',
      preciseFilter: '精准筛选',
      emotion: '情感属性',
      similar: '相似文章',
      sort: '信息排序',
      matchMode: '匹配方式',
      dataSource: '数据来源',
      websiteName: '网站名称',
      author: '作者名称',
      organization: '涉及机构',
      categoryLabel: '文章分类',
      enterpriseType: '涉及企业',
      highTechType: '高科技型企业',
      policyLabel: '涉及政策',
      dataSourceType: '数据品类',
      eventIndex: '涉及事件',
      industryIndex: '涉及行业',
      province: '涉及省份',
      city: '涉及城市',
    },
    feedback: {
      title: '反馈建议',
      content: '您的反馈',
      submit: '提交反馈',
    },
  },
}

export default zhCN
